import { QUERY_GET_FACTORY_TYPES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryTypes = baseThunk(`factoryTypes/getTypes`, QUERY_GET_FACTORY_TYPES, "GET")
